import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { includes } from 'lodash';

import { loadRecordingsByFilter } from '../../actions/recording';
import * as facetActions from '../../actions/facet';
import * as clientActions from '../../actions/client';

import { selectProfile } from '../../selectors/profile';

import { selectRecordingsFilterParams } from '../../selectors/filteredList';
import FilteredRecordingList from '../common/FilteredRecordingList';
import { selectActiveRecordingFacets } from '../../selectors/facet';
import dataComponent from '../../hoc/dataComponent';
import { compose } from 'redux';
import { messages } from '../messages/Profile';
import {
  selectFilteredAndSortedRecordings,
  selectNextFilteredRecordingsCursor,
  selectPreviousFilteredRecordingsCursor,
} from '../../selectors/recording';
import * as Shapes from '../../shapes';
import { getBaseHelmet } from '../../utils/profile';
import { META_TITLE_PREFIX } from '../../constants';

class ProfileRecordings extends Component {
  static propTypes = {
    profileId: PropTypes.string.isRequired,
    profileIsEnsemble: PropTypes.bool.isRequired,
    profileIsPerformer: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    filterParams: PropTypes.object.isRequired,
    activeFacets: PropTypes.array.isRequired,
    recordings: PropTypes.arrayOf(Shapes.Recording).isRequired,
  };

  static onDataFetch(store, params, location, intl) {
    const state = store.getState();
    const profile = selectProfile(state, params.slug);
    const query = location.query;
    const filterParams = selectRecordingsFilterParams(query, profile.id, 'artists');
    const { name } = profile;
    const title = intl.formatMessage(messages.profileRecordingsMetaTitle, { name });
    const description = intl.formatMessage(messages.profileRecordingsMetaDescription, { name });
    store.dispatch(
      clientActions.setHelmet({
        ...getBaseHelmet(profile, location, intl),
        title: META_TITLE_PREFIX + title,
        description,
        canonicalRoute: `/profiles/${params.slug}/recordings`,
        keywords: intl.formatMessage(messages.profileRecordingsMetaKeywords, { name }),
        ogTitle: title,
        ogDescription: intl.formatMessage(messages.profileRecordingsOgDescription, { name }),
        currentCursor: params.cursor,
        nextCursor: selectNextFilteredRecordingsCursor(state, filterParams),
        prevCursor: selectPreviousFilteredRecordingsCursor(state, filterParams),
      })
    );
  }

  render() {
    const {
      profileId,
      profileIsEnsemble,
      profileIsPerformer,
      location,
      params,
      filterParams,
      activeFacets,
      recordings,
    } = this.props;

    return (
      <FilteredRecordingList
        location={location}
        params={params}
        contextType="profile"
        contextFacet={profileIsEnsemble ? 'Ensemble' : 'Artist'}
        contextId={profileId}
        handleMultipleComposers={profileIsPerformer}
        filterParams={filterParams}
        activeFacets={activeFacets}
        recordings={recordings}
      />
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { slug } = ownProps.params;
  const profile = selectProfile(state, slug);
  const profileIsEnsemble = includes(profile.functions, 'ensemble');
  const location = ownProps.location;
  const filterParams = selectRecordingsFilterParams(location.query, profile.id, 'artists');
  const activeFacets = selectActiveRecordingFacets(state, filterParams, 'artists');

  return {
    filterParams,
    profileId: profile.id.toString(),
    profileIsPerformer: !!profile.numRecordingsAsPerformer,
    profileIsEnsemble,
    location,
    activeFacets,
    recordings: selectFilteredAndSortedRecordings(state, filterParams),
  };
}

function fetchData(store, { slug, cursor }, location) {
  const state = store.getState();
  const profile = selectProfile(state, slug);
  const filterParams = selectRecordingsFilterParams(location.query, profile.id, 'artists');
  return [
    store.dispatch(loadRecordingsByFilter(filterParams, cursor, __CAPACITOR__ ? 20 : 50)),
    store.dispatch(facetActions.loadTopRecordingFacets(filterParams)),
  ];
}

export default compose(dataComponent(fetchData), connect(mapStateToProps, {}))(ProfileRecordings);
